export default __webpack_public_path__ + "static/media/Hamburger.a2e254dd.svg";